import React, { useMemo } from "react";
import {
  ObjectPriorityCssClasses,
  ObjectPriorityTitles,
  PriorityTypeEnum
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";

const getValue = (type) => {
  if (type) {
    if (type === "Low" || type === "1") return 1;
    if (type === "Medium" || type === "2") return 2;
    if (type === "High" || type === "3") return 3;
    if (type === "Urgent" || type === "4") return 4;
  } else return 0;
};

const setRow = (row) => {
  return (
    < span
      className={`label label-lg label-light-${ObjectPriorityCssClasses[getValue(row.priority)]} label-inline`
      }
    >
      <FormattedMessage id={ObjectPriorityTitles[getValue(row.priority)]} />
    </span >
  )
}

export const PriorityColumnFormatter = (cellContent, row) => setRow(row);

export const indexN = (cellContent, row, index) => {
  return (<div>{index}</div>)
}